// extracted by mini-css-extract-plugin
export default {"gallery":"ModifyMedia_gallery__4RTXL"};